"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview2_exports = {};
__export(GeodesPreview2_exports, {
  default: () => GeodesPreview2_default
});
module.exports = __toCommonJS(GeodesPreview2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.16797 14.4102C5.16797 14.7357 5.27865 15.0156 5.5 15.25C5.73438 15.4714 6.01432 15.582 6.33984 15.582H14.6602C14.9857 15.582 15.2591 15.4714 15.4805 15.25C15.7148 15.0156 15.832 14.7357 15.832 14.4102V10.9336C15.832 10.8034 15.8776 10.6927 15.9688 10.6016C16.0729 10.4974 16.1966 10.4453 16.3398 10.4453C16.4701 10.4453 16.5807 10.4974 16.6719 10.6016C16.776 10.6927 16.8281 10.8034 16.8281 10.9336V14.4102C16.8281 15.0091 16.6133 15.5234 16.1836 15.9531C15.7669 16.3698 15.2591 16.5781 14.6602 16.5781H6.33984C5.74089 16.5781 5.22656 16.3698 4.79688 15.9531C4.38021 15.5234 4.17188 15.0091 4.17188 14.4102V6.08984C4.17188 5.49089 4.38021 4.98307 4.79688 4.56641C5.22656 4.13672 5.74089 3.92188 6.33984 3.92188H9.77734C9.90755 3.92188 10.0182 3.97396 10.1094 4.07812C10.2135 4.16927 10.2656 4.27995 10.2656 4.41016C10.2656 4.55339 10.2135 4.67708 10.1094 4.78125C10.0182 4.8724 9.90755 4.91797 9.77734 4.91797H6.33984C6.01432 4.91797 5.73438 5.03516 5.5 5.26953C5.27865 5.49089 5.16797 5.76432 5.16797 6.08984V14.4102ZM9.07422 11.0703C9.10026 11.0833 9.11979 11.0898 9.13281 11.0898C9.14583 11.0898 9.15885 11.0833 9.17188 11.0703C9.23698 11.0703 9.29557 11.0573 9.34766 11.0312C9.39974 11.0052 9.4388 10.9661 9.46484 10.9141C10.1029 9.97656 10.819 9.27344 11.6133 8.80469C12.4076 8.32292 13.3255 8.0625 14.3672 8.02344V9.68359C14.3672 9.72266 14.3737 9.75521 14.3867 9.78125C14.3997 9.80729 14.4128 9.83984 14.4258 9.87891C14.4518 9.90495 14.4779 9.93099 14.5039 9.95703C14.5299 9.97005 14.556 9.98307 14.582 9.99609C14.6081 10.0091 14.6406 10.0221 14.6797 10.0352C14.7188 10.0352 14.7513 10.0286 14.7773 10.0156C14.8164 10.0156 14.849 10.0091 14.875 9.99609C14.901 9.97005 14.9271 9.94401 14.9531 9.91797L18.7227 6.20703C18.7617 6.18099 18.7878 6.14844 18.8008 6.10938C18.8268 6.05729 18.8398 6.01172 18.8398 5.97266C18.8398 5.92057 18.8268 5.875 18.8008 5.83594C18.7878 5.79688 18.7617 5.75781 18.7227 5.71875L14.9531 2.00781C14.9271 1.99479 14.901 1.98177 14.875 1.96875C14.849 1.94271 14.8164 1.92969 14.7773 1.92969C14.7513 1.91667 14.7188 1.91667 14.6797 1.92969C14.6406 1.92969 14.6081 1.9362 14.582 1.94922C14.556 1.96224 14.5299 1.98177 14.5039 2.00781C14.4779 2.02083 14.4518 2.04036 14.4258 2.06641C14.4128 2.09245 14.3997 2.125 14.3867 2.16406C14.3737 2.1901 14.3672 2.22266 14.3672 2.26172V3.96094C13.5078 4.0651 12.7331 4.29948 12.043 4.66406C11.3529 5.02865 10.7669 5.50391 10.2852 6.08984C9.81641 6.66276 9.45833 7.33984 9.21094 8.12109C8.96354 8.91536 8.83984 9.78776 8.83984 10.7383C8.83984 10.7773 8.83984 10.8164 8.83984 10.8555C8.85286 10.8945 8.8724 10.9271 8.89844 10.9531C8.92448 10.9792 8.95052 11.0052 8.97656 11.0312C9.0026 11.0573 9.03516 11.0703 9.07422 11.0703Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview2_default = SvgGeodesPreview2;
